<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    activeIndex: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    canGoBack: { type: Boolean, default: false },
});

const emit = defineEmits(['goToSlide', 'prevQuestion']);

const visibleSteps = computed(() => {
    const active = props.activeIndex;

    if (active <= 0) return [0];
    if (active === 1) return [0, 1];

    return [active - 2, active - 1, active].filter((i) => i >= 0);
});

const isDisabledDot = (index) => {
    const active = props.activeIndex;

    // активную точку не дизейблим, просто не кликаем
    if (index === active) return true;

    // если есть окно из 3: самая левая = active-2 => disabled
    return active >= 2 && index === active - 2;


};

const handleDotClick = (index) => {
    if (index === props.activeIndex) return;
    if (isDisabledDot(index)) return;

    emit('goToSlide', index);
};

const handlePrevClick = () => emit('prevQuestion');
</script>

<template>
    <div class="custom-pagination">
        <div
            v-if="canGoBack"
            class="custom-pagination__arrow"
            @click="handlePrevClick"
        >
            <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.91406 0.707031L1.41406 8.20703L8.91406 15.707" stroke="#464646" stroke-width="2"/>
            </svg>
        </div>

        <div class="custom-pagination__dots">
            <div
                v-for="index in visibleSteps"
                :key="index"
                class="custom-pagination__dots-item"
                :class="{
                    _active: activeIndex === index,
                    _disabled: isDisabledDot(index) && activeIndex !== index
                }"
                @click="handleDotClick(index)"
            >
                <span>
                    {{ index + 1 }}
                </span>
            </div>
        </div>
    </div>
</template>
